import { createSlice } from "@reduxjs/toolkit";
import cookies from "js-cookie";
import jwt_decode from "jwt-decode";

import { ServerError, UserSession } from "@/lib/types";

import { ProfileState } from "@/store/types";
import { getProfile, getSignIn, getSignOut } from "@/store/actions/profile-actions";

const access_token = cookies.get("access_token");

const initialState: ProfileState = {
  loading: false,
  error: "",
  session: access_token ? jwt_decode<UserSession>(access_token) : null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ============= sign in =============
      .addCase(getSignIn.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSignIn.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.session = payload;
      })
      .addCase(getSignIn.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload?.message;
      })
      // ============= sign out =============
      .addCase(getSignOut.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSignOut.fulfilled, (state) => {
        state.loading = false;
        state.session = null;
      })
      .addCase(getSignOut.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // ============= profile =============
      .addCase(getProfile.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(getProfile.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(getProfile.rejected, (state, { error }) => {
        state.loading = false;
      })
  }
});

export default profileSlice.reducer;
